import React, { useEffect } from 'react';

import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';

import LandingPage from './components/LandingPage';

import Privacy from './components/Privacy';

import Terms from './components/Terms';

import './App.css';
 
// Reliable scroll-to-hash handler

function ScrollToHash() {

  const location = useLocation();
 
  useEffect(() => {

    if (!location.hash) return;
 
    const id = location.hash.replace('#', '');
 
    // retry until element exists

    const scrollToElement = () => {

      const el = document.getElementById(id);

      if (el) {

        el.scrollIntoView({ behavior: 'smooth' });

      } else {

        // try again after 100ms (DOM not ready yet)

        setTimeout(scrollToElement, 100);

      }

    };
 
    scrollToElement();

  }, [location]);
 
  return null;

}
 
function App() {

  return (
<Router>
<ScrollToHash />
 
      <Routes>
<Route path="/" element={<LandingPage />} />
<Route path="/privacy" element={<Privacy />} />
<Route path="/terms" element={<Terms />} />
</Routes>
</Router>

  );

}
 
export default App;

 